import type {PageRouteConfig} from '@router';

import ExtraDeliveryList from 'modules/Services/PromotionCenter/ExtraDelivery/List/ExtraDeliveryList';
import {routes} from 'routes/routes';

export function createPromotionCenterExtraDeliveryListRoute(): PageRouteConfig {
  return {
    element: <ExtraDeliveryList />,
    layout: {
      title: 'محدوده پوشش‌دهی',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.PROMOTION_CENTER
    }
  };
}
